export default __webpack_public_path__ + "static/media/PrintedMaterial3.0a46c721.png";